export const AUTH_INITIAL_ID_TOKEN_KEY = '_fs_initial_id_token';
export const AUTH_REDIRECT_SEARCH_PARAMS = '_fs_auth_redirect_search_params';
